import { ClientType } from '../back-office/clients-accounts/client-type';
import { Role } from './guards/role';

export class UserData {
  public name: string;
  public initialName: string;
  public roles: Role;
  public fleets: string[];
  public client: string; // GUID
  public sub: string;
  public aud: string;
}

export class DisplayedClient {
  public client: string;
  public clientType: ClientType;
}
